export const text = {
    addActivity : 'Add Activity',
    editActivity : 'Edit Activity',
    newActivity : "New Activity",
    skip : "skip",
    cancel : "cancel",
    submit : "submit",
    or : "or",
    uploadVideo : "upload video",
    uploadImage : "upload image",
    'no-item': 'No Item',
    'selectGym': 'Please select studio before selecting a coach',
    'selectRoom': 'Please select studio before selecting a room',
}